import { useTranslation } from "react-i18next"

export function NotFound(){
    const {t} = useTranslation()

    return (
        <h1>{ t('page__not_found__message') }</h1>
    )
}